import React, { useState, useContext, useEffect } from 'react'
import PatientContext from '../../../context/patientContext';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { BsFillPlusSquareFill, BsPencilSquare } from 'react-icons/bs';
import EarQQuestionGroup from './EarQQuestionGroup'
import ErrorDialogModal from '../modals/ErrorDialogModal';
import DictionaryContext from '../../../context/dictionaryContext'
import UserPrefContext from '../../../context/userPrefContext'
import AuthContext from '../../../context/authContext';
import { useNavigate } from "react-router-dom"
import { useOktaAuth } from '@okta/okta-react'
import Logout from '../../../Logout';
import { Form } from 'react-bootstrap';
import './EarQModal.css';
import EarQEditModal from './EarQEditModal';
import EarQListModal from './EarQListModal';

function EarQModal(props) {

    // console.log("EarQModal - props", props)
    const { authState, oktaAuth } = useOktaAuth()
    const navigate = useNavigate()

    const panelName = 'earq_panel'
    const visCtx = useContext(PatientContext);
    const dictCtx = useContext(DictionaryContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)

    

    // const [show, setShow] = useState(false);
    // const [formId, setFormId] = useState()
    // const [groups, setGroups] = useState([])
    // const [sortedQuestions, setSortedQuestions] = useState([])
    // const [modalTitle, setModalTitle] = useState('')
    // const [earQValues, setEarQValues] = useState({})
    // const [errors, setErrors] = useState([])
    const [showError, setShowError] = useState(false);
    const [doLogout, setDoLogout] = useState(false)
    // const [language, setLanguage] = useState("")
    const [earQOptions, setEarQOptions] = useState({mode: 'hide', earQ: null})
    const [updateDeleteCount, setUpdateDeleteCount] = useState(0)

    // const onLanguageChange = (event) => {
    //   // console.log("Language changed to", event.target.value )
    //   setLanguage(event.target.value)
    // }


    // useEffect(() => {
    //     if (dictCtx.dict_intake_form.length > 0) {
    //         const intakeForm = dictCtx.dict_intake_form.find(form => {
    //             return form.display_name_short === panelName.replace("_panel","")
    //         })

    //         if (intakeForm !== undefined) {
    //             // setIntakeFormId(intakeForm.id)
    //             // sort questions by sort_position
    //             const questions = dictCtx.dict_intake_form_question.filter(quest => {
    //                 return quest.DictIntakeFormQuestion.dict_intake_form_id === intakeForm.id && quest.DictIntakeFormQuestion.question_option_values !== null &&
    //                   !!quest.DictIntakeFormQuestion.is_active 

    //             })

    //             setFormId(intakeForm.id);
                
    //             const comp = (a,b) => {
    //                 var agrp = (+a.DictIntakeFormQuestion.group_id) * 100 + (+a.DictIntakeFormQuestion.sort_position)
    //                 var bgrp = (+b.DictIntakeFormQuestion.group_id) * 100 + (+b.DictIntakeFormQuestion.sort_position)
    //                 return agrp - bgrp
    //             }
    //             // const sortedQuestions = questions.sort((a,b) => a.sort_position - b.sort_postion)
    //             let sortedQs = questions.sort(comp)
    //             sortedQs = sortedQs.map(q => {
    //               return {
    //                 id: q.DictIntakeFormQuestion.id,
    //                 question: q.DictIntakeFormQuestion,
    //                 is_required: q.DictIntakeFormQuestion.is_required,
    //               }
    //             })
    //             console.log("Sorted questions", sortedQs)
    //             setSortedQuestions(sortedQs)

    //             if (props.mode === 'ipad' && !!props.patient) {
    //                 // ipad mode - get user name from props.patient
    //                 setModalTitle(`${intakeForm.display_name} - ${props.patient.last_name}, ${props.patient.first_name}`)
    //             } else {
    //                 // "normal mode - take patient details from patient context"
    //                 setModalTitle(`${intakeForm.display_name} - ${visCtx.pat_last}, ${visCtx.pat_first}`)
    //             }
                


    //             // create result object for EarQ like {q0:0, q1:0,...}
    //             // we will use this object to post results
    //             const fiVals = sortedQs.reduce((accum, element) => {
    //                 // accum[element.DictIntakeFormQuestion.display_name_short] = 0
    //                 accum[element.question.id] = 0
    //                 return accum
    //             }, {})

    //             // console.log("earQ fiVals", fiVals)
    //             setEarQValues(fiVals)



    //             // setFormQuestions(sortedQuestions)

    //             // get group_ids of questions (only one id per group)
    //             const groups_c = sortedQs
    //                 .map((value, index, qs) => (index > 0 && qs[index-1].question.group_id === value.question.group_id) ? null : value.question.group_id)
    //                 .filter(value => value !== null)

    //             // console.log("groups",groups_c)
    //             setGroups(groups_c)
    //         }

    //         // ipad mode
    //         if (!!props.mode && props.mode === 'ipad') {
    //             setShow(true)
    //         }
    //     }
    // }, [dictCtx.dict_intake_form.length, visCtx, props.mode, props.patient])


    // const valueChanged = (question, value) => {
    //     // console.log("faceInstrumentValues", faceInstrumentValues)
    //     // console.log("Question value changed! Question:", question, ", Value:", value)
    //     setEarQValues({...earQValues, [question]:value})
    // }

    // validate and save changes
    // const handleSave = () => {
    //     // console.log("earQValues before save", earQValues)

    //     // make sure we have all values set 
    //     const keys = Object.keys(earQValues)

    //     // console.log("earQValues", earQValues)
    //     // console.log("Errors - sortedQuestions", sortedQuestions)
    //     const errorsArr = keys.filter((key) => {
    //         // console.log("Errors - key", key)
    //         // console.log("Errors - question", sortedQuestions.find(q => q.id == key))
    //         return earQValues[key] === 0 && !!sortedQuestions.find(q => q.id == key).is_required
    //     })

    //     setErrors(errorsArr)

    //     // console.log("Errors - missing values in questions", errorsArr)

    //     // if errors array is empty then all fields populated; otherwise some are not
    //     if (errorsArr.length === 0) {
    //         // save data
    //         saveEarQ()

    //         if (props.mode === 'main') {
    //             // change last updated time
    //             if (!!props.setLastUpdatedTime) {
    //                 props.setLastUpdatedTime(new Date().getTime())
    //             }
    //             setShow(false)
    //         } else if (props.mode === 'ipad') {
    //             // ipad mode - log out
    //             logout()
    //         }
            
    //     }        
    // }


    // child dialog was closed
    const handleClose = () => {
        // console.log("******* handleClose - mode", eFaceMode)
        switch (earQOptions.mode) {
            case 'list':
                // close button was clicked in the list mode - change to hide
                // if any of the efaces were updated or deleted let know the parent component to refresh
                // console.log("Closing the list - updateDeleteCount", updateDeleteCount)
                if (updateDeleteCount > 0) {
                    forceRefreshEarQs()
                    setUpdateDeleteCount(0)
                }
                setEarQOptions({mode:'hide', earQ:null})
                break;

            case 'new':
                // close/save button was clicked in the new mode - change to hide
                setEarQOptions({mode:'hide', earQ:null})
                break;
            case 'editing':
                // close/save/delete button was clicked in the list mode - change to list
                setEarQOptions({mode:'list', earQ:null})
                break;
            case 'ipad':
                logout();
                break;
        } 
    }

    // const handleClose = () => {
    //     if (props.mode === 'ipad') {
    //         logout()
    //     } else {
    //         // setErrors([])
    //         setShow(false)
    //     }
    // }


    // const logout = () => {
    //     // console.log("logging out")
    //     oktaAuth.signOut()
    //     navigate('/')
    // }


    const handleShow = () => {
      setEarQOptions({mode: 'new', earQ: null})
    }

    const handleShowList = () => {
        setEarQOptions({mode: 'list', earQ: null})
    }

    const onSelect = (earQ) => {
      setEarQOptions({mode:'editing', earQ: earQ})
    }


    // const saveEarQ = async() => {
    //     try {
    //         // console.log("Creating face instruments", JSON.stringify(faceInstrumentValues))
    //         let earQCreateURL = ''
    //         if (props.mode === 'ipad' && !!props.patient) {
    //             // ipad mode - get patient token from props.patient
    //             earQCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/earq/from_ipad/${props.patient.form_id}/${props.patient.patient_token}`
    //         } else {
    //             // "normal" mode - take patient token from patient context
    //             earQCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/form_responses/${visCtx.pat_token}`
    //         }

    //         const groupped = Object.groupBy(sortedQuestions, q => q.question.group_display_name_short)
    //         // console.log("groupped", groupped)

    //         // const dict_intake_form_id = sortedQuestions[0].question.DictIntakeForm.id;
    //         const groupVals = Object.keys(groupped).map(gname => {
    //           const groupAnswers = sortedQuestions.filter(sq => sq.question.group_display_name_short == gname)
    //           // console.log("groupAnswers for group", gname, groupAnswers)

    //           const vals = groupAnswers.map(ga => { 
    //             return {[ga.id]: earQValues[ga.id] }
    //           })

    //           const theVals = vals.reduce((accum, v, index, arr) => {
    //             const key = Object.keys(v)[0];
    //             return {...accum, [key]: v[key]  }
    //           },{})

    //           // console.log("theVals", theVals)

    //           return {
    //             scale: gname,
    //             // dict_intake_form_id: dict_intake_form_id,
    //             dict_intake_form_id:formId,
    //             // answers: earQValues.filter(eqv => eqv)
    //             answers: theVals,
    //           }
    //         })

    //         // console.log("groupVals", groupVals)

    //         const body = {
    //           surveys: groupVals
    //         }

    //         console.log("body", body)
            
    //         const response = await fetch(earQCreateURL, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
    //                 'accept': 'application/json',
    //                 auth: authCtx.authMode,
    //             },
    //             method: "POST",
    //             // body: JSON.stringify(earQValues),
    //             body: JSON.stringify(body),
    //         })

    //         if (response.status === 200) {
    //             const responseData = await response.json()
    //             // console.log("Created Face Instruments: responseData", responseData)
                

    //         } else {
    //             console.log("Failed to create Ear-Q", response)
    //             if (!response.ok) {
    //                 throw new Error('Unprocessable Entity: ' + response.statusText);
    //            }
    //         }
    //     } catch (e) {
    //         console.log("Failed to create Ear-Q", e)
    //         setShowError(true);
    //     }

    // }

        // this will be called from the EFace List if an eface was updated or deleted
    // we'll use it to let the paremt component know to update eface view when the list dialog is closed
    const onUpdateOrDelete = () => {
        setUpdateDeleteCount(updateDeleteCount+1)
    }

    const forceRefreshEarQs = () => {
        // let know parent component that data has been changed, so it can refresh
        setTimeout(() => {
            props.onUpdate()
            // props.setLastUpdatedTime(new Date())
        }, 200)
    }


    const logout = () => {
        setDoLogout(true)
    }

    const loggedOut = () => {
        setDoLogout(false)
    }

    return (
        <>
            {(!!!props.mode  || (!!props.mode && props.mode !== 'ipad')) && 
              <>
                <BsFillPlusSquareFill onClick={handleShow} className="icon-pointer"/>
                <BsPencilSquare onClick={handleShowList} className="icon-pointer"/>
              </>
            }

            {earQOptions && (earQOptions.mode === 'new' || earQOptions.mode === 'editing' ) &&
                <EarQEditModal earQOptions={earQOptions} 
                    show={true} 
                    onClose={handleClose} 
                    onSaveOrDelete={earQOptions.mode === 'new' ? forceRefreshEarQs : onUpdateOrDelete}
                />
            }

            {earQOptions && earQOptions.mode === 'list' &&
                <EarQListModal 
                    show={true} 
                    onClose={handleClose} 
                    onSelect={onSelect}
                    onUpdateOrDelete={onUpdateOrDelete}
                    updateDeleteCount={updateDeleteCount}
                />
            }

            <ErrorDialogModal
                setOpen={showError}
                close={() => setShowError(false)}
                componentName="Ear-Q"
            />
            {/* {show && 
            <Modal size="fullscreen" show={show} onHide={handleClose} animation={false}
                style={{ visibility: (showError) ? 'hidden' : 'visible' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                      <h4>{modalTitle}</h4>
                      <Form.Check className='language-radio'
                        inline
                        label="English"
                        name="earq_form_language"
                        type="radio"
                        id="earq_form_language_en"
                        value=''
                        onChange={onLanguageChange}
                        defaultChecked
                      />
                      <Form.Check className='language-radio'
                        inline
                        label="Español"
                        name="earq_form_language"
                        type="radio"
                        id="earq_form_language_es"
                        value='_es'
                        onChange={onLanguageChange}
                      />
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        {groups.map((group_id, index) => 
                            <EarQQuestionGroup 
                                key={index}
                                group_id={group_id}
                                questions={sortedQuestions.filter(q => q.question.group_id === group_id)}
                                onChange={valueChanged}
                                errors={errors}
                                // language='_es'
                                language={language}
                            />
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer className='justify-content-between'>
                    <div className='w-100'>
                        {errors.length > 0 && <span style={{color:'red', fontWeight:'bold'}} className='text-danger font-weight-bold'>All fields must be populated!</span>}
                    </div>
                    
                    <div className="inline-block text-left">
                        <Button className='mx-2' variant="secondary" onClick={handleClose}>
                            {props.mode === 'ipad' ? 'Logout' : 'Close'}
                        </Button>
                    </div>
                    <div className='inline-block text-right'>
                        <Button className='mx-2' variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>
                    </div>
                    
                </Modal.Footer>
            </Modal>
            } */}
            <Logout doLogout={doLogout} onLoggedOut={loggedOut} /> 
        </>
    )
}

export default EarQModal
